import type { Geometry } from '../../../types/apiModels'
import { apiClient } from '../../ruutsApi/client'
import endpoints from '../../ruutsApi/endpoints'
import { unwrapVoid } from '../../ruutsApi/normalize'

const PERIMETER_COLOR = 'hsl(61, 90%, 71%)'

// PUT /v1/farms answers a message-only envelope (no payload).
export const updatePerimeter = async ({
  farm,
  geometry,
  center,
}: {
  farm: { id: string; name: string }
  geometry: Geometry
  center: [number, number]
}): Promise<void> => {
  const response = await apiClient.put(endpoints.farms, {
    id: farm.id,
    data: {
      name: farm.name,
      geometry,
      uncroppedGeometry: geometry,
      lat: center[0],
      lng: center[1],
      color: PERIMETER_COLOR,
    },
  })
  return unwrapVoid(response)
}
